// LiveStreamChatroomGift.js
import { connect } from 'react-redux';
import LiveStreamChatroomGift from '../component/LiveStreamChatroomGift.jsx';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getUserData from '../selector/getUserData.js';
import fetchUser from '../action/fetchUser.js';
import fetchGift from '../action/fetchGift.js';
import getListData from '../selector/getListData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import {
  STREAM_EXPENSIVE_GIFT_PRICE,
  FEATURE_DISPLAY_NAME,
} from '../RemoteConfigKeys.js';
import { livestreamNoticeType } from '../resource/liveStreamConstants.js';

const mapStateToProps = (state, { streamId }) => {
  const isDisplayNameEnabled =
    getRemoteConfigData(state, FEATURE_DISPLAY_NAME) === 1;
  const noticeType = livestreamNoticeType.GIFT_NOTICE;
  const giftNoticeIds =
    getListData(state, ['liveStream', streamId, noticeType], 'itemIds') || [];
  const giftNoticeId = giftNoticeIds[0];
  const giftNoticeSelectPath = [streamId, noticeType, giftNoticeId];
  const noticeStatus = getLiveStreamData(state, giftNoticeSelectPath, 'status');
  const senderId = getLiveStreamData(state, giftNoticeSelectPath, 'senderId');
  const senderDisplayName = getUserData(state, senderId, 'displayName');
  const senderUsername =
    getLiveStreamData(state, giftNoticeSelectPath, 'username') ||
    getUserData(state, senderId, 'username') ||
    '';
  const senderName = isDisplayNameEnabled
    ? senderDisplayName || `@${senderUsername}`
    : `@${senderUsername}`;
  const senderLevel = getLiveStreamData(
    state,
    giftNoticeSelectPath,
    'senderLevel'
  );
  const senderBadges = getLiveStreamData(
    state,
    giftNoticeSelectPath,
    'senderBadges'
  );
  const giftId = getLiveStreamData(state, giftNoticeSelectPath, 'giftId');
  const giftPrice = getLiveStreamData(state, giftNoticeSelectPath, 'price');

  return {
    noticeStatus,
    senderId,
    senderName,
    senderLevel,
    giftId,
    giftPrice,
    expensivePrice:
      +getRemoteConfigData(state, STREAM_EXPENSIVE_GIFT_PRICE) || 0,
    senderBadges,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUser: ({ userId }) => dispatch(fetchUser({ id: userId })),
    fetchGift: ({ giftId }) => dispatch(fetchGift({ giftId })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamChatroomGift);
